// Errors owned by a recoverable editor must not discard the document/ad context.
// Keep identity, not message matching: unrelated stale chunks still recover.
const containedFailures = new WeakSet<object>();
export function containModuleFailure(error: unknown) {
  if (error && (typeof error === "object" || typeof error === "function")) containedFailures.add(error);
}
export function isContainedModuleFailure(error: unknown) {
  return !!error && (typeof error === "object" || typeof error === "function") && containedFailures.has(error);
}

const RETRY_KEY = "personaos.vitePreloadRetryAt";
export function reloadAfterStaleModuleFailure(reason: unknown) {
  // Vite dispatches preloadError BEFORE import().catch runs. Defer the decision
  // so the feature can claim this exact rejection, without suppressing others.
  window.setTimeout(() => {
    if (isContainedModuleFailure(reason)) return;
    try {
      const lastRetryAt = Number(sessionStorage.getItem(RETRY_KEY));
      if (Number.isFinite(lastRetryAt) && Date.now() - lastRetryAt <= 10_000) return;
      sessionStorage.setItem(RETRY_KEY, String(Date.now()));
    } catch { /* Preserve existing recovery when session storage is unavailable. */ }
    window.location.reload();
  }, 250);
}

export function installModulePreloadRecovery() {
  const listener = (event: Event) => {
    // Do not preventDefault: Vite must reject the import for local boundaries
    // to receive the real error instead of resolving React.lazy with undefined.
    reloadAfterStaleModuleFailure((event as Event & { payload?: unknown }).payload);
  };
  window.addEventListener("vite:preloadError", listener);
  return () => window.removeEventListener("vite:preloadError", listener);
}
